module.exports = __webpack_public_path__ + "img/img_50_default_profile@2x.e06bbbbf.png";